import React from 'react';
import {
  Heading1,
  Paragraph,
  Span,
  LinkStyled,
  Heading2,
} from '../../components/typography';
import { Container, Row, Col } from '../../components/grid';
import { Image } from '../../components/Image';
import {
  Price,
  MomsChange,
  ItemTraverser,
} from '../../containers/commerce';
import SidemenuLayout from '../../layout/DefaultLayout/Layouts/SidemenuLayout';
import RowProductView from '../../components/grid/RowProductView';
import ProductView1 from '../../components/commerce/ProductViews/ProductView1';

export default () => (
  <SidemenuLayout menuPicker="Kildevand" activeSidemenu="VandPaller">
    <Container white mb>
      <Row>
        <Col xs={12} paddingBottom="0">
          <Heading1>Kildevand i hele paller</Heading1>
        </Col>
        <Col xs={12} sm={6}>
          <Paragraph>
            Til storaftagere tilbyder vi en helt fantastisk lav pris. Kan du modtage hele paller med kildevand er der virkelig meget at spare.
            Vi er lagerførende i hele paller med både 30 cl, 50 cl og 125 cl Dansk Aqua d&apos;or kildevand fra den Jyske hede.
          </Paragraph>
          <Paragraph>
            Du bestiller, og vi leverer normalt inden for 2 arbejdsdage.
            I København og omegn leverer vi jeres kildevand med vores egne chauffører.
            I resten af landet sender vi med fragtfirmaet DSV.
            Kildevandet køres så langt som muligt med palleløftevogn.
            I må selv sætte kasserne på plads, men til gengæld er prisen også helt i bund.
          </Paragraph>
          <Paragraph>
            Se vores store sortiment af <LinkStyled to="/kildevand" title="Kildevand">kildevand</LinkStyled>.
          </Paragraph>
          <Paragraph fontSize="18px" bold>
            Priserne er med fri levering i hele landet (brofaste øer).
          </Paragraph>
        </Col>
        <Col xs={12} sm={6}>
          <Span bold>Holdbarhed og pant på kildevand</Span><br />
          <Paragraph>
            Holdbarheden på Aqua d&apos;or og Denice vand er mellem 6-12 måneder.
          </Paragraph>
          <Paragraph>
            Flaskerne skal returneres til Dansk-Retursystem, bortset fra Pure Water vand i pap, der blot kan smides ud efter brug.
          </Paragraph>
          <Paragraph>
            Panten på eur-paller er kr. <Price embPrice varenr="888" /> <MomsChange />.
          </Paragraph>
          <Paragraph>
            <Span bold>Fakturering og betaling</Span><br />
            Private og offentlige virksomheder faktureres med 14 dages betalingsfrist.
            Vi sender gerne faktura elektronisk via EAN nummer.
          </Paragraph>
        </Col>
      </Row>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12} paddingBottom="15px">
          <Heading2>Denice kildevand i hele paller</Heading2>
          <Span fontSize="12px" block>
            Pantpriser, 50cl: 1,20 + moms = 1,50 DKK.<br />
            Vi tager ikke engangs-plastflasker retur. Disse afhentes gratis - og panten refunderes af Dansk Retursystem, kræver tilmelding.
          </Span>
          <Span fontSize="12px">Følgende priser <MomsChange />, uden pant</Span>
        </Col>
      </Row>
    </Container>
    <Container>
      <RowProductView>
        <ItemTraverser includedCategories={['kildevandPaller', 'kildevandDenice']} display={ProductView1} />
      </RowProductView>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12} paddingBottom="15px">
          <Heading2>Aqua d&apos;or kildevand i hele paller</Heading2>
          <Span fontSize="12px" block>
            Pantpriser, 30cl og 50cl: 1,20 + moms = 1,50 DKK. 125cl: 2,40 + moms = 3,00 DKK.<br />
            Vi tager ikke eengangs-plastflasker retur. Disse afhentes gratis - og panten refunderes af Dansk Retursystem, kræver tilmelding.
          </Span>
          <Span fontSize="12px">Følgende priser <MomsChange />, uden pant</Span>
        </Col>
      </Row>
    </Container>
    <Container>
      <RowProductView>
        <ItemTraverser includedCategories={['kildevandPaller', 'aquadorPalle']} display={ProductView1} />
      </RowProductView>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12} paddingBottom="15px">
          <Heading2>Aqua d&apos;or kildevand med blid brus i paller</Heading2>
          <Span fontSize="12px" block>
            Pantpriser, 50cl: 1,20 + moms = 1,50 DKK. 100cl: 2,40 + moms = 3,00 DKK.<br />
            Vi tager ikke eengangs-plastflasker retur. Disse afhentes gratis - og panten refunderes af Dansk Retursystem, kræver tilmelding.
          </Span>
          <Span fontSize="12px">Følgende priser <MomsChange />, uden pant</Span>
        </Col>
      </Row>
    </Container>
    <Container>
      <RowProductView>
        <ItemTraverser includedCategories={['kildevandPaller', 'aquadorBlidPalle']} display={ProductView1} />
      </RowProductView>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12} paddingBottom="15px">
          <Heading2>Egekilde kildevand uden brus i paller</Heading2>
          <Span fontSize="12px" block>
            Pantpriser, 50cl: 1,20 + moms = 1,50 DKK. 100cl: 2,40 + moms = 3,00 DKK.<br />
            Vi tager ikke eengangs-plastflasker retur. Disse afhentes gratis - og panten refunderes af Dansk Retursystem, kræver tilmelding.
          </Span>
          <Span fontSize="12px">Følgende priser <MomsChange />, uden pant</Span>
        </Col>
      </Row>
    </Container>
    <Container>
      <RowProductView>
        <ItemTraverser includedCategories={['kildevandPaller', 'egekildepalle']} display={ProductView1} />
      </RowProductView>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12} paddingBottom="15px">
          <Heading2>Vand uden pant i paller</Heading2>
          <Span fontSize="12px" block>
            Ingen pant.
          </Span>
          <Span fontSize="12px">Følgende priser <MomsChange />, uden pant</Span>
        </Col>
      </Row>
    </Container>
    <Container>
      <RowProductView>
        <ItemTraverser includedCategories={['kildevandPaller', 'palleUdenPant']} display={ProductView1} />
      </RowProductView>
    </Container>
    <Container white mb>
      <Row>
        <Col xs={12} sm={6} textCenter>
          <Image name="oel-vand.aquador-palle.gif" alt="Eur-palle med 78 rammer 0,51 l Aqua d'or kildevand A-Pant" title="Eur-palle med 78 rammer 0,51 l Aqua d'or kildevand A-Pant" />
          <Paragraph fontSize="12px">
            Hel eur-palle, 1560 Aqua d&apos;or<br />
            BxLxH 80x120x141 cm<br />
            Vægt 840 Kg
          </Paragraph>
        </Col>
        <Col xs={12} sm={6} textCenter>
          <Image name="oel-vand.aquador-05palle.gif" alt="Halv Eur-palle med 720 flasker 0,50 l Aqua d'or kildevand B-Pant" title="Halv Eur-palle med 720 flasker 0,50 l Aqua d'or kildevand B-Pant" />
          <Paragraph fontSize="12px">
            Halv eur-palle med 720 Denice<br />
            BxLxH 80x60x141cm<br />
            Vægt: 420 kg
          </Paragraph>
        </Col>
      </Row>
    </Container>
  </SidemenuLayout>
);
